import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import getHoverFlyoutModifiers from '@Utils/Flyout';

const TOOLTIP_ENABLED_PROPERTY = '--ai-summary-action-tooltip-enabled';

function SummaryActionTooltip({ label, children, onlyWhenLabelHidden = false }) {
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = useCallback(
    (nextOpen) => {
      if (!nextOpen) {
        setIsOpen(false);
        return;
      }

      const trigger = triggerRef.current;
      const isTooltipEnabled =
        !onlyWhenLabelHidden ||
        Boolean(trigger && window.getComputedStyle(trigger).getPropertyValue(TOOLTIP_ENABLED_PROPERTY).trim() === '1');
      setIsOpen(isTooltipEnabled);
    },
    [onlyWhenLabelHidden]
  );

  return (
    <div ref={triggerRef} className="ai-search-summary__action-tooltip-trigger">
      <Flyout
        placement="top-start"
        trigger="hover"
        width="max-content"
        theme="simple"
        pointerType="primary"
        flyout={
          <span className="ai-search-summary__action-tooltip" aria-hidden="true">
            {label}
          </span>
        }
        modifiers={getHoverFlyoutModifiers()}
        shouldCloseOnESC
        isControlled
        isOpen={isOpen}
        onToggle={handleToggle}>
        {children}
      </Flyout>
    </div>
  );
}

SummaryActionTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onlyWhenLabelHidden: PropTypes.bool,
};

export default SummaryActionTooltip;
